module.exports = "../../app/cells/pages/questions/challenge_feedback_cell.rb";